import { NgModule } from '@angular/core';
import { HighlightSearchPipe } from '../pipes/highlight-search.pipe';
import { DispatchCountPipe } from '../pipes/dispatchboard-status-total.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        HighlightSearchPipe,
        DispatchCountPipe

    ], 
    exports: [
        HighlightSearchPipe,
        DispatchCountPipe
    ]
})
export class pipeModule { }
